import { Result } from 'antd'
import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { contextCompanyIdSelector } from '../../../../../../redux/context/company/selectors'
import { useBackend } from '../../../../../../services/backend'

interface NeptonApiProps {
  credentialsRequestUrl: string
}

const NeptonApi = ({ credentialsRequestUrl }: NeptonApiProps) => {
  const { t } = useTranslation()
  const companyId = useSelector(contextCompanyIdSelector)
  const credentialsRequest = useBackend(credentialsRequestUrl, process.env.REACT_APP_INTEGRATION_URL)
  const [authorized, setAuthorized] = useState(false)

  const getCredentialsHandler = () => {
    credentialsRequest
      .get({
        urlParams: { companyId }
      })
      .then((res: { httpCode: number }) => {
        res.httpCode === 200 && setAuthorized(true)
      })
      .catch(() => {
        setAuthorized(false)
      })
  }

  useEffect(getCredentialsHandler, [companyId])

  return authorized ? (
    <>
      <Result status="success" title={t('integrationsPage:authenticated')} />
    </>
  ) : (
    <>
      <Result status="info" title={t('integrationsPage:notAuthenticated')} />
    </>
  )
}

export default NeptonApi
